"use strict";

exports.__esModule = true;
exports.StyledValueBar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _polished = require("polished");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getWidth = progress => {
  if (!progress || progress < 0) {
    return '0%';
  } else if (progress > 100) {
    return '100%';
  } else {
    return `${progress}%`;
  }
};

const getBorderRadius = height => {
  const [value, units] = (0, _polished.getValueAndUnit)(height);
  return `${value / 2}${units}`;
};

const StyledValueBar = (0, _styledComponents.default)(({
  height,
  width,
  color,
  value,
  theme,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", { ...otherProps
}))`
    height: ${({
  height
}) => height};
    width: ${({
  value
}) => getWidth(value)};
    border-radius: ${({
  height
}) => getBorderRadius(height)};
    background-color: ${({
  color,
  theme
}) => color ? color : theme.colors.valueBar.bar};
`;
exports.StyledValueBar = StyledValueBar;